import React, { useEffect, useMemo } from "react";
import classes from "./PaginationComp.module.css";

export default function PaginationComp({
  total,
  perPage,
  currentPage,
  onPageChange,
}) {
  const totalPages = Math.ceil(total / perPage);
  const safePage = Math.min(Math.max(currentPage, 1), Math.max(totalPages, 1));

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [safePage]);

  const paginationItems = useMemo(() => {
    if (totalPages <= 4) {
      return [...Array(totalPages).keys()].map((i) => i + 1);
    }

    const items = [];
    items.push(1);

    if (safePage > 3) {
      items.push("left-dot");
    }

    const middleStart = Math.max(2, safePage - 1);
    const middleEnd = Math.min(totalPages - 1, safePage + 1);

    for (let i = middleStart; i <= middleEnd; i += 1) {
      items.push(i);
    }

    if (safePage < totalPages - 2) {
      items.push("right-dot");
    }

    items.push(totalPages);
    return items;
  }, [totalPages, safePage]);

  if (totalPages <= 1) return null;

  const handleChange = (page) => {
    if (page === safePage || page < 1 || page > totalPages) return;
    onPageChange(page);
  };

  return (
    <div className={classes.pagination}>
      <button
        className={classes.pageBtn}
        disabled={safePage === 1}
        type="button"
        onClick={() => handleChange(safePage - 1)}
      >
        Prev
      </button>

      {paginationItems.map((item, idx) =>
        typeof item === "string" ? (
          <span key={idx} className={classes.ellipsis}>
            ...
          </span>
        ) : (
          <button
            key={idx}
            className={`${classes.pageBtn} ${
              safePage === item ? classes.active : ""
            }`}
            type="button"
            onClick={() => handleChange(item)}
          >
            {item}
          </button>
        )
      )}

      <button
        className={classes.pageBtn}
        disabled={safePage === totalPages}
        type="button"
        onClick={() => handleChange(safePage + 1)}
      >
        Next
      </button>
    </div>
  );
}
